module.exports = __webpack_public_path__ + "dado-capital--6af8462e.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/parceiros/dado-capital.png
// module id = 237
// module chunks = 0